import React, { FC } from 'react';
import { CustomIcon } from 'components/CustomIcon';
import TypographyComponent from 'components/Typography/Typography';
import * as Styled from './ContactRepModalView.styles';
import { Option } from '../../types';

interface CompleteStateProps {
  selectedRepresentative: Option | null;
}

export const CompleteState: FC<CompleteStateProps> = ({
  selectedRepresentative,
}) => {
  return (
    <Styled.StatusMessage>
      <CustomIcon name="circle-check" size={1.5} />
      <TypographyComponent variant="body">
        {selectedRepresentative ? selectedRepresentative.label : 'Brand Rep'}{' '}
        will follow up soon through your inbox.
      </TypographyComponent>
    </Styled.StatusMessage>
  );
};
